
export class TokenLogin {
    password: string;
    evaluationContext: number;

    constructor(password: string, evaluationContext: number) {
        this.password = password;
        this.evaluationContext = evaluationContext;
    }
}